import React, { useState,useEffect } from "react";
import ReactDOM from "react-dom";
import emailjs from "emailjs-com";
import "../styles/ContactForm.css";

const ContactForm = ({ onClose }) => {
  const [formStatus, setFormStatus] = useState("");
  useEffect(() => {
  document.body.classList.add("modal-open");
  return () => document.body.classList.remove("modal-open");
}, []);
  const sendEmail = (e) => {
    e.preventDefault();
    setFormStatus("");

    emailjs
      .sendForm("service_i1ffejd", "template_ma51e0o", e.target, "qZCA0Pyy9LSMIs2wl")
      .then(
        () => setFormStatus({ type: "success", message: "✅ Message sent successfully!" }),
        () => setFormStatus({ type: "error", message: "❌ Failed to send. Please try again." })
      );

    e.target.reset();
  };

  const modal = (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Send Us a Message</h3>

        <form className="contact-form" onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Name" required />
          {/* <input type="email" name="email" placeholder="Email" /> */}
          <input type="tel" maxLength="10" name="phone" placeholder="Phone Number" required />
          {/* <input type="text" name="subject" placeholder="Subject" required /> */}
          <textarea name="message" placeholder="Message" required></textarea>

          <div className="form-buttons">
            <button type="submit">Submit</button>
            <button type="button" className="close-btn" onClick={onClose}>
              Cancel
            </button>
          </div>

          {formStatus && (
            <p className={`form-status ${formStatus.type}`}>
              {formStatus.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};

export default ContactForm;
